import { Fetch, schemas, SaveNotebookBodyType } from '@convergence/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function saveNotebook(
  data: SaveNotebookBodyType,
  title: string,
  fetch: Fetch
) {
  return fetch(
    `/notebook/${title}`,
    { method: 'PATCH', body: JSON.stringify(data) },
    schemas.NotebookDto
  );
}

export const useSaveNotebookMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['saveNotebook'],
    mutationFn: async ({
      data,
      title
    }: {
      data: SaveNotebookBodyType;
      title: string;
    }) => {
      const result = saveNotebook(data, title, fetch);
      return result;
    },

    onSuccess: async (res) => {
      console.log('saved');
      await queryClient.invalidateQueries({
        queryKey: ['notebook', res.title]
      });
    }
  });
};
